import { render, staticRenderFns } from "./prefix-item.vue?vue&type=template&id=180ca3e6"
import script from "./prefix-item.vue?vue&type=script&lang=js"
export * from "./prefix-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports